import React from "react";
import { Accordion, Typography, AccordionDetails, styled } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";

import Management from "../Management";
import AgentNotes from "../AgentNotes";
import { useAdminProviderDataContext } from "../../../../context";

const StyledAccordion = styled(Accordion)({ backgroundColor: "#f2f2f2" });

const SubAgentDataAccordion = (): React.ReactElement => {
  const agent = useSelector((state) => state.agent);

  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  return (
    <div>
      {allowed_features.agent_notes_change_status_or_remove && (
        <StyledAccordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight={700}>
              Notes: {agent.data.admin_accounts_notes.active_notes}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <AgentNotes />
          </AccordionDetails>
        </StyledAccordion>
      )}

      <StyledAccordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={700}>Management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Management />
        </AccordionDetails>
      </StyledAccordion>
    </div>
  );
};

export default SubAgentDataAccordion;
